module.exports = __webpack_public_path__ + "f02f3b1af0eda2c88d9a7ae67234c564.otf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/HelveticaNeue/HelveticaNeueLTStd-MdIt.otf
// module id = 342
// module chunks = 0